export const reconcileFinalBotMessage = (lastMessage, responseMessage) => {
  if (!responseMessage) return lastMessage;
  if (!lastMessage || lastMessage.sender !== "bot") return responseMessage;

  const preservedRuntimeFields = {};
  if (lastMessage.__stableKey) {
    preservedRuntimeFields.__stableKey = lastMessage.__stableKey;
  }
  if (lastMessage.__localKey) {
    preservedRuntimeFields.__localKey = lastMessage.__localKey;
  }

  const streamedText = typeof lastMessage.message === "string"
    ? lastMessage.message
    : "";
  const finalText = typeof responseMessage.message === "string"
    ? responseMessage.message
    : "";

  // A post-answer failure (e.g. an OpenAI timeout during follow-up/ticker
  // extraction) returns an error body even though the full answer already
  // streamed in over the WS. Keep the streamed answer and its chart rather than
  // letting the error string overwrite them; only surface the error when nothing
  // was streamed.
  if (responseMessage.isError) {
    return streamedText ? lastMessage : responseMessage;
  }

  if (streamedText === finalText) {
    return {
      ...lastMessage,
      ...responseMessage,
      ...preservedRuntimeFields,
      message: streamedText,
    };
  }

  if (streamedText && finalText.startsWith(streamedText)) {
    return {
      ...lastMessage,
      ...responseMessage,
      ...preservedRuntimeFields,
      message: streamedText,
    };
  }

  return {
    ...lastMessage,
    ...responseMessage,
    ...preservedRuntimeFields,
  };
};
